module.exports = __webpack_public_path__ + "static/media/form.b0e0b38a.gif";